module.exports = __webpack_public_path__ + "img/20230403135424297wmr.72c61cfe.jpg";